// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__1wBAM","page":"Pagination_page__-ymUz","page_icon":"Pagination_page_icon__2-sZ-","button":"Pagination_button__QHnK2"};